import React from 'react'
import type { Except } from 'type-fest'
import type { HTMLElementProps } from '~/types'
import { cn } from '~/utils'
import { Close } from '../Icons'

interface SearchInputProps extends Except<HTMLElementProps<'input'>, 'onChange'> {
	onChange: (value: string) => void
	containerClassName?: string
}

export const SearchInput: React.FC<SearchInputProps> = ({
	value,
	onChange,
	placeholder,
	className,
	containerClassName,
	...props
}) => (
	<div className={cn('relative', containerClassName)}>
		<input
			type="text"
			name="search"
			placeholder={placeholder}
			value={value}
			onChange={e => onChange(e.target.value)}
			className={cn('!mb-0', className)}
			{...props}
		/>
		{value && (
			<button
				type="button"
				className="button absolute inset-y-0 right-0 flex items-center px-3"
				onClick={() => onChange('')}
			>
				<Close className="h-5 w-5 text-gray-400" />
			</button>
		)}
	</div>
)
